import { jsx as g } from "react/jsx-runtime";
import { Box as c } from "@telegraph/layout";
import { useStyleEngine as d } from "@telegraph/style-engine";
import u from "clsx";
const V = {
  color: {
    cssVar: "--color",
    value: "var(--tgph-VARIABLE)"
  },
  fontSize: {
    cssVar: "--font-size",
    value: "var(--tgph-text-VARIABLE)"
  },
  weight: {
    cssVar: "--weight",
    value: "var(--tgph-weight-VARIABLE)"
  },
  leading: {
    cssVar: "--leading",
    value: "var(--tgph-leading-VARIABLE)"
  },
  tracking: {
    cssVar: "--tracking",
    value: "var(--tgph-tracking-VARIABLE)"
  },
  align: {
    cssVar: "--text-align",
    value: "VARIABLE"
  },
  family: {
    cssVar: "--font-family",
    value: "var(--tgph-family-VARIABLE)"
  },
  textOverflow: {
    cssVar: "--text-overflow",
    value: "VARIABLE"
  }
}, A = V, f = {
  default: "gray-12",
  gray: "gray-11",
  red: "red-11",
  beige: "beige-11",
  blue: "blue-11",
  green: "green-11",
  yellow: "yellow-11",
  purple: "purple-11",
  accent: "accent-11",
  white: "white",
  black: "black",
  disabled: "gray-9"
}, E = ({
  as: r,
  size: e = "2",
  weight: t = "semi-bold",
  color: a,
  align: o,
  className: l,
  // Remove this from props to avoid passing to DOM element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  internal_optionalAs: i,
  ...n
}) => {
  if (!r) throw new Error("as prop is required");
  const { styleProp: p, otherProps: s } = d({
    props: {
      color: f[a],
      fontSize: e,
      tracking: e,
      leading: e,
      weight: t,
      align: o,
      ...n
    },
    cssVars: A
  });
  return /* @__PURE__ */ g(
    c,
    {
      as: r,
      className: u("tgph-heading", l),
      display: "inline",
      m: "0",
      style: p,
      ...s
    }
  );
}, x = ({
  as: r,
  size: e = "2",
  weight: t = "regular",
  align: a = "left",
  color: o,
  className: l,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  internal_optionalAs: i,
  ...n
}) => {
  if (!r) throw new Error("as prop is required");
  const { styleProp: p, otherProps: s } = d({
    props: {
      color: f[o],
      fontSize: e,
      tracking: e,
      leading: e,
      weight: t,
      align: a,
      ...n
    },
    cssVars: A
  });
  return /* @__PURE__ */ g(
    c,
    {
      as: r,
      className: u("tgph-text", l),
      display: "inline",
      style: p,
      ...s
    }
  );
}, m = {
  default: "gray-3",
  gray: "gray-3",
  red: "red-3",
  beige: "beige-3",
  blue: "blue-3",
  green: "green-3",
  yellow: "yellow-3",
  purple: "purple-3",
  accent: "accent-3"
}, R = ({
  as: r,
  size: e = "2",
  weight: t = "regular",
  variant: a = "soft",
  align: o = "left",
  family: l = "mono",
  color: i,
  className: n,
  // Remove this from props to avoid passing to DOM element
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  internal_optionalAs: p,
  ...s
}) => {
  if (!r) throw new Error("as prop is required");
  const { styleProp: y, otherProps: h } = d({
    props: {
      color: f[i],
      fontSize: `code-${e}`,
      leading: `code-${e}`,
      weight: t,
      align: o,
      family: l,
      ...s
    },
    cssVars: A
  });
  return /* @__PURE__ */ g(
    c,
    {
      as: r,
      className: u("tgph-code", n),
      bg: a === "soft" ? m[i] : "transparent",
      display: "inline",
      m: "0",
      px: "1",
      rounded: "1",
      style: y,
      ...h
    }
  );
};
export {
  R as Code,
  E as Heading,
  x as Text
};
//# sourceMappingURL=index.mjs.map
